module.exports = __webpack_public_path__ + "media/organizations/Porsche-05d715eb.webp";